var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[[_c('settlement-bill-list',{attrs:{"search-field":_vm.settlementListSearchFields,"opt":_vm.settlementBillListOptions,"forms":_vm.forms}})]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }